import { Data_getInstance2448xvec7zq5m as Data_getInstance } from './adapter/DeletePartyMutation_ResponseAdapter.mjs';
import { getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DeletePartyMutation_VariablesAdapter_instance3dxdl476begu0 as DeletePartyMutation_VariablesAdapter_instance } from './adapter/DeletePartyMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
import { ApolloAdaptableWith1g871415y7ifs as ApolloAdaptableWith } from '../../../../../../apollo-kotlin-apollo-annotations/com/apollographql/apollo/annotations/ApolloAdaptableWith.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(deleteParty) {
        this.q6g_1 = deleteParty;
      }
      toString() {
        return 'Data(deleteParty=' + this.q6g_1 + ')';
      }
      hashCode() {
        return this.q6g_1 == null ? 0 : getBooleanHashCode(this.q6g_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!(this.q6g_1 == other.q6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.r6g_1 = '4a11a1598f90772d3be13efb9b91b8b2c0c7c3bbeae17a79a444936647ab7009';
        this.s6g_1 = 'deleteParty';
      }
      g6g() {
        return 'mutation deleteParty($input: DeletePartyInput!) { deleteParty(input: $input) }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var DeletePartyMutationClass;
function DeletePartyMutation() {
  if (DeletePartyMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.t6g_1 = input;
      }
      i6g() {
        return '4a11a1598f90772d3be13efb9b91b8b2c0c7c3bbeae17a79a444936647ab7009';
      }
      operationId() {
        return this.i6g();
      }
      w48() {
        return Companion_instance.g6g();
      }
      j6g() {
        return 'deleteParty';
      }
      operationName() {
        return this.j6g();
      }
      q47(writer, customScalarAdapters, withDefaultValues) {
        DeletePartyMutation_VariablesAdapter_instance.u6g(writer, this, customScalarAdapters, withDefaultValues);
      }
      p47() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'DeletePartyMutation(input=' + this.t6g_1.toString() + ')';
      }
      hashCode() {
        return this.t6g_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeletePartyMutation()))
          return false;
        if (!this.t6g_1.equals(other.t6g_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeletePartyMutation', VOID, VOID, [Mutation()]);
    DeletePartyMutationClass = $;
  }
  return DeletePartyMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  Data as Data3reuiwuuk86jk,
  DeletePartyMutation as DeletePartyMutationn87apg3zfg0d,
};
//endregion

//# sourceMappingURL=DeletePartyMutation.mjs.map
